import {
  START_LOADING_INDICATOR,
  STOP_LOADING_INDICATOR,
} from "./loadingIndicatorTypes";

export const startLoadingIndicator = () => ({ type: START_LOADING_INDICATOR });
export const stopLoadingIndicator = () => ({ type: STOP_LOADING_INDICATOR });
